import { useEffect, useState } from "react";
import { useList, useCreate, useUpdate } from "@/hooks/crud";
import { TextField, TextAreaField, SelectField } from "@/components/Fields";
import { StatusBadge } from "@/components/Badges";
import { ErrorBanner } from "@/components/Feedback";
import { MASTER_STATUSES } from "@/lib/enums";
import type { TrackMaster } from "@/types/database";

export function MasterPanel({ trackId }: { trackId: number }) {
  const { data } = useList("track_master", `track_id=eq.${trackId}`);
  const master = (data?.rows?.[0] ?? null) as TrackMaster | null;

  const create = useCreate("track_master");
  const update = useUpdate("track_master");

  const [status, setStatus] = useState("PENDING");
  const [fileUrl, setFileUrl] = useState("");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    setStatus(master?.status ?? "PENDING");
    setFileUrl(master?.master_file_url ?? "");
    setNotes(master?.notes ?? "");
  }, [master]);

  const mutation = master ? update : create;

  async function save() {
    const body = {
      track_id: trackId,
      status,
      master_file_url: fileUrl.trim() || null,
      notes: notes.trim() || null,
    };
    if (master) await update.mutateAsync({ id: master.id, body });
    else await create.mutateAsync(body);
  }

  return (
    <div className="panel">
      <div className="panel-head">
        <h3>
          Master
          {master && <StatusBadge status={master.status} />}
        </h3>
      </div>
      <div className="panel-body">
        {mutation.error && <ErrorBanner error={mutation.error} />}
        <SelectField
          label="Status"
          value={status}
          onChange={setStatus}
          options={MASTER_STATUSES}
        />
        <TextField label="Master file URL" value={fileUrl} onChange={setFileUrl} />
        <TextAreaField label="Notes" value={notes} onChange={setNotes} rows={2} />
        <div className="row-actions">
          <button
            className="btn btn-primary btn-sm"
            onClick={save}
            disabled={mutation.isPending}
          >
            {mutation.isPending ? "Saving…" : master ? "Save" : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
}
